import { CompanyEntity } from "@ots-frontend/ots-data";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseCompanySelectProps = BaseEntitySelectProps<CompanyEntity>;

export const BaseCompanySelect = (props: BaseCompanySelectProps) => {
  return <BaseEntitySelect {...props} />;
};
